import { render, staticRenderFns } from "./required.vue?vue&type=template&id=2315b9be&scoped=true&"
import script from "./required.vue?vue&type=script&lang=js&"
export * from "./required.vue?vue&type=script&lang=js&"
import style0 from "./required.vue?vue&type=style&index=0&id=2315b9be&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2315b9be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/contactum-new/contactum-new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2315b9be')) {
      api.createRecord('2315b9be', component.options)
    } else {
      api.reload('2315b9be', component.options)
    }
    module.hot.accept("./required.vue?vue&type=template&id=2315b9be&scoped=true&", function () {
      api.rerender('2315b9be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/admin/components/field-template/required.vue"
export default component.exports